<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data Entrada Inicial"
                            v-model="localDataEntradaInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data Entrada Final"
                            v-model="localDataEntradaFinal"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Prazo Resposta Inicial"
                            v-model="localPrazoRespostaInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Prazo Resposta Final"
                            v-model="localPrazoRespostaFinal"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-comprador-multiple
              required
              dense
              class="rounded-tag-small"
              v-model="localComprador"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-select-enum dense
                            chips
                            multiple
                            small-chips
                            deletable-chips
                            class="rounded-tag-small"
                            label="Situação admin"
                            :items="statusSolicitacao"
                            v-model="localStatus"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import StatusSolicitacao from '@/enums/status-solicitacao-enum';

export default {
  data: () => ({
    menuOpened: false,
    localComprador: [],
    localPrazoRespostaInicial: null,
    localPrazoRespostaFinal: null,
    localDataEntradaInicial: null,
    localDataEntradaFinal: null,
    localStatus: null,
    statusSolicitacao: StatusSolicitacao.values,
  }),
  computed: {
    ...mapGetters('listagemCotacao', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    comprador: {
      get() {
        return this.$store.getters['listagemCotacao/comprador'];
      },
      set(comprador) {
        this.$store.dispatch('listagemCotacao/comprador', comprador);
      },
    },
    prazoRespostaInicial: {
      get() {
        return this.$store.getters['listagemCotacao/prazoRespostaInicial'];
      },
      set(prazoRespostaInicial) {
        this.$store.dispatch('listagemCotacao/prazoRespostaInicial', prazoRespostaInicial);
      },
    },
    prazoRespostaFinal: {
      get() {
        return this.$store.getters['listagemCotacao/prazoRespostaFinal'];
      },
      set(prazoRespostaFinal) {
        this.$store.dispatch('listagemCotacao/prazoRespostaFinal', prazoRespostaFinal);
      },
    },
    dataEntradaInicial: {
      get() {
        return this.$store.getters['listagemCotacao/dataEntradaInicial'];
      },
      set(dataEntradaInicial) {
        this.$store.dispatch('listagemCotacao/dataEntradaInicial', dataEntradaInicial);
      },
    },
    dataEntradaFinal: {
      get() {
        return this.$store.getters['listagemCotacao/dataEntradaFinal'];
      },
      set(dataEntradaFinal) {
        this.$store.dispatch('listagemCotacao/dataEntradaFinal', dataEntradaFinal);
      },
    },
    status: {
      get() {
        return this.$store.getters['listagemCotacao/status'];
      },
      set(status) {
        this.$store.dispatch('listagemCotacao/status', status);
      },
    },
  },
  methods: {
    emitChange() {
      this.prazoRespostaInicial = this.localPrazoRespostaInicial;
      this.prazoRespostaFinal = this.localPrazoRespostaFinal;
      this.dataEntradaInicial = this.localDataEntradaInicial;
      this.dataEntradaFinal = this.localDataEntradaFinal;
      this.comprador = this.localComprador;
      this.status = this.localStatus;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localPrazoRespostaInicial = null;
      this.localPrazoRespostaFinal = null;
      this.localDataEntradaInicial = null;
      this.localDataEntradaFinal = null;
      this.localComprador = [];
      this.localStatus = [];
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localPrazoRespostaInicial = this.prazoRespostaInicial || null;
    this.localPrazoRespostaFinal = this.prazoRespostaFinal || null;
    this.localDataEntradaInicial = this.dataEntradaInicial || null;
    this.localDataEntradaFinal = this.dataEntradaFinal || null;
    this.localComprador = this.comprador || [];
    this.localStatus = this.status || [];
  },
};
</script>
